<template>
  <div class="study-class">
    <div class="study-class-banner">
      <img src="@/assets/studyClass/dp-xx-banner1.png" alt />
    </div>
    <div class="study-class-choose">
      <div class="study-class-choose-box">
        <span
          v-for="(data,i) in choose"
          :key="i"
          :class="i == choosed ? 'choosed':''"
          @click="choosed=i"
        >{{data}}</span>
      </div>
      <div class="study-class-choose-posi" @click="goMyclass()">
        <span>我的学习班</span>
        <img src="@/assets/studyClass/dp-xx-path.png" alt />
      </div>
    </div>

    <div class="study-class-all" v-if="choosed == 0">
      <div class="study-class-all-template" v-for="(data,i) in classArr" :key="i">
        <img :src="data.studyimg|img" alt />
        <p class="study-class-all-template-title">{{data.studyname}}</p>
        <p class="study-class-all-template-time">开班时间:{{data.starttime}}</p>
        <p class="study-class-all-template-time">结束时间:{{data.endtime}}</p>
        <label @click="goDetail(data.id)">
          <span :class="judge(data.state)">{{data.state}}</span>
          <span>查看详情</span>
        </label>
      </div>
    </div>

    <div class="study-class-noreport" v-if="choosed == 1">
      <div class="study-class-all-template" v-for="(data,i) in classNoreporyArr" :key="i">
        <img :src="data.studyimg|img" alt />
        <p class="study-class-all-template-title">{{data.studyname}}</p>
        <p class="study-class-all-template-time">开班时间:{{data.starttime}}</p>
        <p class="study-class-all-template-time">结束时间:{{data.endtime}}</p>
        <label @click="goDetail(data.id)">
          <span :class="judge(data.state)">{{data.state}}</span>
          <span>查看详情</span>
        </label>
      </div>
    </div>
    <!-- <button @click="lookDetail(2)">测试</button> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      choose: ["所有学习班", "未报名学习班"],
      choosed: 0,
      classArr: [],
      classNoreporyArr: []
    };
  },
  mounted() {
    this.getmsg();
  },
  methods: {
    getmsg() {
      let url =
        "/api/Index/GetStudyClassindex?userid=" + sessionStorage.getItem("id");
      this.axios.get(url).then(e => {
        if (e.data.code == 0) {
          console.log(e.data.msg);
          
          this.classArr = e.data.msg;
          this.classNoreporyArr = [];
          e.data.msg.filter(item => {            
            if (item.state == "未报名") {
              this.classNoreporyArr.push(item);
            }
          });
          // console.log(this.classArr);
        }
      });
    },
    judge(state) {
      // console.log(state);
      switch (state) {
        case "未报名":
          return "no-report";
          break;
        case "已报名":
          return "readry-report";
          break;
        default:
          return "other-report";
          break;
      }
    },
    goDetail(id) {
      this.$router.push({
        path: "/study/detail",
        query: {
          title: "主题教育学习",
          id: id
        }
      });
    },
    goMyclass(){
      this.$router.push({
        path:'/study/myClass',
        query:{
          title:'我的学习班'
        }
      })
    },
    lookDetail(id) {
      this.$router.push({
        path: "/study/haveClass",
        query: {
          title: "课件学习",
          classId: id,
          studyId: this.$route.query.id
        }
      });
    },
  }
};
</script>
<style lang='scss' scoped>
.study-class {
  &-noreport,
  &-all {
    &-template {
      .other-report {
        background: #bdbdbd;
      }
      .readry-report {
        background: #f9bb52;
      }
      .no-report {
        background: #f55553;
      }
      &-title {
        line-height: 2;
      }
      label {
        span {
          &:nth-child(1) {
            color: #fff;
            border-radius: 0.1rem 0.1rem 0.1rem 0.02rem;
            font-size: 0.22rem;
            padding: 0.05rem;
          }
          &:nth-child(2) {
            text-decoration: underline;
            color: #1095fc;
          }
        }
        display: flex;
        justify-content: space-between;
        margin-top: 0.2rem;
      }
      &-time {
        color: #999999;
        font-size: 0.24rem;
      }
      background: #fff;
      padding: 0.2rem;
    }
    display: grid;
    grid-gap: 2%;
    grid-template-columns: 49% 49%;
    padding: 0.2rem;
  }
  &-choose {
    &-posi {
      img {
        width: 0.1rem;
        height: 0.18rem;
        margin-left: 0.2rem;
      }
      display: flex;
      align-items: center;
      color: #1095fc;
    }
    &-box {
      span {
        margin-right: 0.2rem;
      }
      .choosed {
        color: #000;
        font-weight: bold;
      }
      color: #999999;
    }
    display: flex;
    justify-content: space-between;
    padding: 0.2rem;
  }
  &-banner {
    img {
      width: 100%;
    }
  }
  font-size: 0.3rem;
  padding: 1rem 0;
}
</style>